// extracted by mini-css-extract-plugin
export default {"wrapper":"ExtraGuessPriceItem_wrapper__YoS0f","typeWrapper":"ExtraGuessPriceItem_typeWrapper__r+jbq","input":"ExtraGuessPriceItem_input__IRcV1"};